import type { Item } from '@qoobd/rules';

/** Original item glyphs. Color comes from `currentColor`. */
export function ItemIcon({ item, size = 30 }: { item: Item; size?: number }) {
  const common = { width: size, height: size, viewBox: '0 0 32 32', 'aria-hidden': true } as const;
  if (item === 'rock')
    return (
      <svg {...common}>
        <path d="M7 20 5 14l5-6 8-2 7 4 2 8-4 7-10 1z" fill="currentColor" opacity=".9" />
        <path d="M10 13l5 3 6-4M15 16l1 7" stroke="#16191E" strokeWidth="1.6" fill="none" />
      </svg>
    );
  if (item === 'paper')
    return (
      <svg {...common}>
        <path d="M8 4h11l6 6v18H8z" fill="currentColor" opacity=".9" />
        <path d="M19 4v6h6M11 15h10M11 19h10M11 23h7" stroke="#16191E" strokeWidth="1.6" fill="none" />
      </svg>
    );
  return (
    <svg {...common}>
      <circle cx="9" cy="23" r="4" fill="none" stroke="currentColor" strokeWidth="2.4" />
      <circle cx="23" cy="23" r="4" fill="none" stroke="currentColor" strokeWidth="2.4" />
      <path d="M11.5 20 24 4M20.5 20 8 4" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
}
